import { Component, HostListener, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { NgModel } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DateFormatService } from 'src/app/Services/Utilities/date-format.service';
import { UserInfoService } from 'src/app/Services/Utilities/user-info.service';
import { RegisterFormComponent } from '../Home/login/register-form/register-form.component';
import { VerifyEmailComponent } from '../Home/login/verify-email/verify-email.component';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})
export class AccountComponent implements OnInit {

  hidePassword = true;
  hidePasswordR = true;
  hideConfirmPasswordR = true;

  private dateFormat = new DateFormatService();

  loginModel = {
    password:'',
    passwordE:false,
    email:'',
    emailE:false,
  };

  registerModel = {
    name: '',
    nameE: false,
    telephoneNo: '',
    telephoneNoE: false,
    email: '',
    emailE: false,
    ic: '',
    icE: false,
    pos: '',
    posE: false,
    schoolName: '',
    schoolNameE: false,
    add1: '',
    add1E: false,
    add2: '',
    add3: '',
    postcode: '',
    postcodeE: false,
    city: '',
    cityE: false,
    state: '',
    stateE: false,
    country: '',
    countryE: false,
    nationality: '',
    nationalityE: false,
    faxNo: '',
    password: '',
    passwordE: false,
    confirm_password: '',
    confirm_passwordE: false,

  };

  flag = true;
  validationsMessages = ' ';
  today = Date.now();
  breakpoint: boolean;
  app;
  
  constructor(
    private router: Router,
    private toast: ToastrService,
    private angularFireAuth: AngularFireAuth,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private userinfoSrv: UserInfoService,
    private firestore: AngularFirestore,
  ) {

    const e = this.angularFireAuth.authState.subscribe(async authState =>{
    this.spinner.show()
      if(authState === null){
        this.spinner.hide();
      } else{
        if(authState.emailVerified){
          this.router.navigate(['/profile']);
        }
        this.spinner.hide();
      }
    })
    e.unsubscribe();

  }

  ngOnInit() {

    this.breakpoint = (window.innerWidth <= 800) ? true : false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {

    this.breakpoint = (window.innerWidth <= 800) ? true : false;
  }

  changeForm() {
    this.flag = !this.flag;
    this.registerSuccessful = false;

  }

  newForm(){
    this.dialog.open(RegisterFormComponent, {
      width: '70%',
      height: '90%',
      disableClose: true,
    })
  }

  login() {
    this.loginModel.passwordE = this.validate(this.loginModel.password);
    this.loginModel.emailE = this.validateEmail(this.loginModel.email);

    if(!this.valid()){
      this.toast.error("Incorrect email or password")
      return;
    }

    const email = this.loginModel.email;
    const password = this.loginModel.password;
    this.spinner.show();
    this.angularFireAuth.auth.signInWithEmailAndPassword(email, password)
      .then(async res => {
         await this.firestore.collection('Admin').doc(res.user.uid).get().forEach(async e=>{
          if(e.exists){
            this.toast.success('Welcome to Innozilla', 'Login Successfully !', { timeOut: 3000 });
            const role = [];
            role.push(e.data().Role);
            const snapshot = await this.firestore.collection('Users').doc(res.user.uid).get();
            snapshot.forEach(e=>{
              if (e.exists)
                role.push('User')

              this.userinfoSrv.SetRole(role)
              this.spinner.hide();
              this.router.navigate(['/innovation']);
            })
     
          }else{
            if(res.user.emailVerified){
              this.toast.success('Welcome to Innozilla', 'Login Successfully !', { timeOut: 3000 });
              const snapshot = await this.firestore.collection('Users').doc(res.user.uid).get();
              snapshot.forEach(e=>{
                this.userinfoSrv.SetRole(['User'])

                if(e.exists){
                  this.userinfoSrv.ic = e.data().IC;
                  this.router.navigate(['/profile']);

                }else{
                  this.validationsMessages = 'Invalid email or password.';
                }
              })
            }else{
              this.toast.info("Not yet verified email, please go and verify");
              this.dialog.open(VerifyEmailComponent, {
                width: 'auto',
                height: 'auto',
                disableClose: true,
              })
            }
          }
          this.spinner.hide();
        });
      })
      .catch(err => {
        this.toast.error("Incorrect email or password")
        this.spinner.hide();

      });
  }

  registerSuccessful = false;
  emailFlag = false;
  emailChange(event, model: NgModel) {
    if (!(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(model.value))){
      model.control.setErrors({ invalid: true });
      this.emailFlag = true;
    }else{
      this.emailFlag = false;
    }
  }

  resetPassword = false;
  
  remail: string
  changeR(){
    this.resetPassword = !this.resetPassword
  }


  sendForgetPassword(){
    this.spinner.show();
    this.angularFireAuth.auth.sendPasswordResetEmail(this.remail).then(
      () => {
        this.toast.success("Forget password email has been sent")
      },
      err => {
        this.toast.success(err,"Invalid email or not a valid register email");
      }
    ).finally(()=>{
      this.spinner.hide();
    });
  }
  

  validateEmail(value) {
    if ((/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value))) {
      return false;
    }
    return true;
  }
  validatePhone(value) {
    if (value.length > 8 && value.length < 20) {
      return false;
    }
    return true;
  }

  validate(value) {
    if (!value) {
      return true;
    }
    return false;
  }

  valid(){
    return !this.loginModel.passwordE && !this.loginModel.emailE
  }

  SelectPos(pos) {
    this.registerModel.pos = pos;
  }
  
  async register() {
    let flag = false;

    this.registerModel.nameE = this.validate(this.registerModel.name);
    this.registerModel.telephoneNoE = this.validate(this.registerModel.telephoneNo);
    this.registerModel.emailE = this.validate(this.registerModel.email);

    this.registerModel.icE = this.validate(this.registerModel.ic);
    this.registerModel.posE = this.validate(this.registerModel.pos);
    this.registerModel.schoolNameE = this.validate(this.registerModel.schoolName);
    this.registerModel.add1E = this.validate(this.registerModel.add1);
    this.registerModel.postcodeE = this.validate(this.registerModel.postcode);
    this.registerModel.cityE = this.validate(this.registerModel.city);
    this.registerModel.stateE = this.validate(this.registerModel.state);
    this.registerModel.countryE = this.validate(this.registerModel.country);
    this.registerModel.nationalityE = this.validate(this.registerModel.nationality);
    this.registerModel.passwordE = this.validate(this.registerModel.password);
    this.registerModel.emailE = this.validateEmail(this.registerModel.email);

    if(this.registerModel.nameE || this.registerModel.telephoneNoE || 
      this.registerModel.emailE || this.registerModel.icE ||
      this.registerModel.posE || this.registerModel.schoolNameE ||
      this.registerModel.add1E || this.registerModel.postcodeE ||
      this.registerModel.cityE || this.registerModel.stateE ||
      this.registerModel.countryE || this.registerModel.nationalityE ||
      this.registerModel.passwordE || this.registerModel.emailE
    ){
      flag = true;
    }

  
    if (this.registerModel.password.length < 6) {
      this.registerModel.passwordE = true;
      this.registerModel.confirm_passwordE = true;
      flag = true;
    }
   
    if (this.registerModel.password != this.registerModel.confirm_password) {
      this.toast.error("The password is not same");
      this.registerModel.passwordE = true;
      this.registerModel.confirm_passwordE = true;
      flag = true;
    }

    if (flag) {
      this.toast.error("Please make sure the form is filled in correct value")
      return;
    }

    const email = this.registerModel.email;
    const password = this.registerModel.password;

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.height = 'auto';
    dialogConfig.width = 'auto';

    const position = { top: '10%' };
    dialogConfig.position = position;
    dialogConfig.disableClose = true;
    dialogConfig.data = 'Confirm register with this information?';

    this.dialog.open(ConfirmationDialogComponent, dialogConfig).afterClosed().subscribe(async data => {
      if(data){
        this.spinner.show();

        await this.angularFireAuth.auth.createUserWithEmailAndPassword(email, password)
        .then(async fbAuth => {
          let newUserInfo = {
            CreatedDate: new Date(),
            UpdatedDate: new Date(),
            CreatedBy: email,
            UpdatedBy: email,
            Email: email,
            Role: "User",
            Name: this.registerModel.name,
            TelephoneNo: this.registerModel.telephoneNo,
            IC: this.registerModel.ic,
            Position: this.registerModel.pos,
            SchoolName: this.registerModel.schoolName,
            Address1: this.registerModel.add1,
            Address2: this.registerModel.add2,
            Address3: this.registerModel.add3,
            State: this.registerModel.state,
            Postcode: this.registerModel.postcode,
            Country: this.registerModel.country,
            City: this.registerModel.city,
            Nationality: this.registerModel.nationality,
            FaxNo: this.registerModel.faxNo
          }
          const dateFormat = this.dateFormat.convertDateIntoYearMonthDay(new Date());
          const info = {
            message: "New User has been register. Email: " + email,
            date: new Date()
          };
          this.spinner.hide();
          await this.firestore.collection("Users").doc(fbAuth.user.uid).set(newUserInfo);
          await this.firestore.collection('UsersLog').doc(dateFormat).set({ Date: new Date() });
          await this.firestore.collection('UsersLog').doc(dateFormat).collection('User').add(info);
          await fbAuth.user.sendEmailVerification().then(e=>{
            console.log(e);
          }).catch(error=>{
            console.log(error);
          });
          this.toast.success("Verification email has been sent, please verify", 'Register successfully', { timeOut: 3000 });
          this.dialog.open(VerifyEmailComponent, {
            width: 'auto',
            height: 'auto',
            disableClose: true,
            data: 300
          }).afterClosed().subscribe(s=>{
            this.flag = true;
          })
        })
        .catch(err => {
          this.toast.error(err, 'Failed to register', { timeOut: 3000 });
          this.spinner.hide();

        }).finally(()=>{
          this.spinner.hide();
        })
      }
    });



  }

  async download() {
    const url = 'https://firebasestorage.googleapis.com/v0/b/innozilla-1a662.appspot.com/o/Registration.pdf?alt=media&token=ede1625a-a1d5-4b9a-b10b-180e57692a62'
    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
    let file = new Blob([existingPdfBytes], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
    var fileURL = URL.createObjectURL(file);
    var anchor = document.createElement("a");
    anchor.download = "RegistrationGuide.pdf";
    anchor.href = fileURL;
    anchor.click();
  }

}
